
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";

interface VehicleDetailsTableProps {
  details: Array<{ label: string; value: string | number | null }>;
}

const VehicleDetailsTable = ({ details }: VehicleDetailsTableProps) => {
  return (
    <Table>
      <TableBody>
        {details.map(
          ({ label, value }) =>
            value && (
              <TableRow
                key={label}
                className="hover:bg-gray-50"
              >
                <TableCell className="text-sm text-gray-600 font-medium border-none">
                  {label}
                </TableCell>
                <TableCell className="text-gray-900 text-right border-none">
                  {value}
                </TableCell>
              </TableRow>
            )
        )}
      </TableBody>
    </Table>
  );
};

export default VehicleDetailsTable;
